import { useState, useEffect } from "react"
import {
    Sparkles,
} from "lucide-react"
import { useCRUDController, Button, message } from "./ot"


const AIGenerateButton = ({
    aiButtonName = "AI一鍵生成",
    aiButtonClassName = "bg-green-500 hover:bg-purple-600 text-white",
    showAIButtonIcon = true,
    aiGenerateQuantityRecommendationsAPIRoute = "/utility/ai_produce/controller/quantity_recommendations",
    target = "文案",
    propsSelectionOptions = [],
    propsComponentData = [],
    onComponentQuantityRecommendationsResultChange = () => { },
}) => {

    const onAIFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === 'get') {
            } else if (axiosMode === "post") {
                onComponentQuantityRecommendationsResultChange(values)
            } else if (axiosMode === "patch") {
            } else if (axiosMode === "delete") {
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("AI生成失敗，請再試一次");
            }
            // else if (axiosMode === "patch") {
            //     actionRef.current.reloadAndRest();
            // } else if (axiosMode === "delete") {
            //     actionRef.current.reloadAndRest();
            // }
        }
    };
    const AiControllers = useCRUDController({ apiRoute: aiGenerateQuantityRecommendationsAPIRoute, onFinish: onAIFinish })


    useEffect(() => {
    }, [])


    return (<>
        <Button
            loading={AiControllers?.loading}
            className={aiButtonClassName}
            onClick={() => {
                AiControllers.postData([
                    {
                        target: target,
                        input: propsComponentData,
                        ...propsSelectionOptions
                    }
                ])
            }}
        >
            {showAIButtonIcon && <Sparkles className="w-4 h-4 mr-2" />}
            {aiButtonName}
        </Button>
    </>)
}

export default AIGenerateButton;
